import CustomerDashboardPreview from './CustomerDashboardPreview';

export default function CustomerDashboard() {
  return <CustomerDashboardPreview useDashboardPageShell />;
}
